/**
 * Logo / mark de Fideliza. Adopta el color primario del tenant si está cargado
 * via CSS var --brand-primary. Default verde sage de la plataforma.
 */
export function LeafMark({ size = 36, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path
        d="M32 12c-10 9-14 18-14 25 0 9 7 15 14 15s14-6 14-15c0-7-4-16-14-25z"
        fill="var(--brand-primary, #4a6921)"
      />
      <path
        d="M32 20c-3 5-3 11 0 17"
        stroke="#ffffff"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
